import React from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  DialogActions,
  TextField,
  Typography,
  Box,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { styles } from '../Account/styles';
import Loading from '../Loading';

const AddWebhookModal = (props) => {
  const {
    open,
    handleClose,
    handleAddWebhook,
    newWebhook,
    setNewWebhook,
    isLoading,
    webhookUrl,
    webhookType,
  } = props;
  const [editSecret, setEditSecret] = React.useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setNewWebhook((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const webhookExists = () => {
    return (
      webhookUrl &&
      webhookUrl !== 'null' &&
      webhookUrl !== '' &&
      webhookUrl.toLowerCase() !== 'n/a'
    );
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      onSubmit={handleAddWebhook}
      component="form"
    >
      {isLoading ? (
        <DialogContent sx={styles.loadingBox}>
          <Loading />
        </DialogContent>
      ) : (
        <>
          <DialogTitle id="alert-dialog-title">
            {webhookExists() ? 'Edit' : 'Add'} {webhookType === 'DEVICE_MEASUREMENT' ? 'Device Measurement' : 'Order Updates'} Webhook
          </DialogTitle>
          <DialogContent sx={styles.contentBox}>
            <Box display="flex" alignItems="center">
              <Typography sx={styles.label} variant="body1">
                Webhook URL: 
              </Typography>
              <TextField
                name="url"
                size="small"
                sx={styles.input}
                type="text"
                defaultValue={webhookExists() ? webhookUrl : ''}
                onChange={handleChange}
                required
              />
            </Box>
            {!webhookExists() && (
              <Box display="flex" alignItems="center" mt={2}>
                <Typography sx={styles.label} variant="body1">
                  Webhook Secret:
                </Typography>
                <TextField
                  name="secret"
                  size="small"
                  sx={styles.input}
                  type="text"
                  onChange={handleChange}
                  required
                />
              </Box>
            )}
            {webhookExists() && (
              <Box>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={editSecret}
                      onChange={(e) => setEditSecret(e.target.checked)}
                      name="editSecret"
                    />
                  }
                  label="Edit secret"
                />
                {editSecret && (
                  <Box display="flex" alignItems="center" mt={1}>
                    <Typography sx={styles.label} variant="body1">
                      New Secret:
                    </Typography>
                    <TextField
                      name="secret"
                      size="small"
                      sx={styles.input}
                      type="text"
                      onChange={handleChange}
                      required
                    />
                  </Box>
                )}
                {editSecret && (
                  <Typography variant="caption" color="textSecondary" mt={1} ml={4}>
                    Editing the webhook secret overwrites the previous value and
                    cannot be undone.
                  </Typography>
                )}
              </Box>
            )}
          </DialogContent>
          <DialogActions sx={{ padding: 3 }}>
            <Button onClick={handleClose} variant="outlined">
              Cancel
            </Button>
            <Button variant="contained" type="submit" autoFocus>
              {
                webhookExists() ? 'Update' : 'Add'
              }
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default AddWebhookModal;
